import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SelectMunicipalityDialogComponent } from "./select-municipality-dialog/select-municipality-dialog.component";

@Component({
    selector: "app-select-municipality",
    templateUrl: "./select-municipality.component.html",
    styleUrls: ["./select-municipality.component.scss"],
})
export class SelectMunicipalityComponent implements OnInit {
    constructor(private _dialog: MatDialog) {
        const clientId = localStorage.getItem('clientId');
        this.openSelectMunicipalityDialog();
    }

    openSelectMunicipalityDialog(): void {
        this._dialog.open(SelectMunicipalityDialogComponent, {
            height: "90vh",
            minWidth: "90%",
            // minWidth: "1350px",
            autoFocus: false,
            maxHeight: "90vh",
            disableClose: true,
            //   width: '95vw',
            //   height: '98%',
            //   autoFocus: false
        });
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/select-municipality/select-municipality.component.ts